import $ from "jquery";

class ClassToggle {
	constructor() {
		this.init();
	}

    init() {
        this.dom();
        this.events();
        this.setInitialState();
    }

	dom() {
        this.$body = $('body');
		this.$toggles = this.$body.find('[data-toggle-target][data-toggle-class]');
        this.$toggleContainers = this.$body.find('.toggle-container');
	}

    events() {
        this.$toggles.off('click.ClassToggle');
        this.$toggles.on('click.ClassToggle', this.clickToggleHandler.bind(this));
    }

    clickToggleHandler(event) {
        event.preventDefault();
        
        const $toggle = $(event.currentTarget);
        const toggleAction = $toggle.data('toggle-action');

        if (toggleAction === 'open') {
            this.addTargetClass($toggle);
        } else if (toggleAction === 'close') {
            this.removeTargetClass($toggle);
        } else {
            this.toggleTargetClass($toggle);
        }
    }

    setInitialState() {
        this.$toggles.each((i) => {
            const $toggle = this.$toggles.eq(i);
            const $container = this.getContainer($toggle);

            if ($container.hasClass('is-active') || $toggle.hasClass('is-active')) {
                this.addTargetClass($toggle);
            }
        });
    }

    toggleTargetClass($toggle) {
        const $container = this.getContainer($toggle);
        const $target = this.getTarget($toggle);
        const toggleClass = $toggle.data('toggle-class');

        if ($target.length < 1 || !toggleClass) return;

        if ($target.hasClass(toggleClass)) {
            $target.removeClass(toggleClass);
            $container.removeClass('is-active');
            $toggle.removeClass('is-active');
        } else {
            $target.addClass(toggleClass);
            $container.addClass('is-active');
            $toggle.addClass('is-active');
        }
    }

    addTargetClass($toggle) {
        const $container = this.getContainer($toggle);
        const $target = this.getTarget($toggle);
        const toggleClass = $toggle.data('toggle-class');

        if ($target.length < 1 || !toggleClass) return;

        $target.addClass(toggleClass);
        $container.addClass('is-active');
        $toggle.addClass('is-active');
    }

    removeTargetClass($toggle) {
        const $container = this.getContainer($toggle);
        const $target = this.getTarget($toggle);
        const toggleClass = $toggle.data('toggle-class');

        if ($target.length < 1 || !toggleClass) return;

        $target.removeClass(toggleClass);
        $container.removeClass('is-active');
        $toggle.removeClass('is-active');
    }

    getTarget($toggle) {
        return $($toggle.data('toggle-target'));
    }

    getContainer($toggle) {
        const $container = $toggle.closest(this.$toggleContainers);
        return ($container.length > 0) ? $container : $toggle;
    }
}

export default ClassToggle;